// extracted by mini-css-extract-plugin
export default {"box":"TopBrands_box__BrHyl","icon":"TopBrands_icon__6MT4G","container":"TopBrands_container__UBfxw"};